import { createContext } from 'react'
import type { ContextTypes, MedicalExpenseItem } from './types'

const defaultValue: ContextTypes = {
  forms: {
    insuredPersonForm: {} as any,
    treatmentDetailForm: {} as any,
    compensationRequestForm: {} as any,
  },
  getAllFormValues: () => ({
    insuredPersonData: {
      identityId: '',
      firstName: '',
      lastName: '',
      dob: null,
      phoneNumber: '',
      email: '',
    },
    treatmentDetailData: {
      treatmentTypeId: '',
      treatmentDateIn: null,
      isOtherHospital: false,
    },
    compensationRequestData: {
      treatmentAmount: 0,
      reimbursementMethod: 'BANK',
      isUserPolicyAddress: false,
      receiptNumber: '',
    },
    medicalExpenseData: {
      medicalExpenses: [],
    },
  }),
  validateAllForms: async (_options?: { overrideErrorMessage?: string }) => false,
  initializeFormsWithData: () => undefined,
  updateMedicalExpenseItem: function (
    key: string,
    field: 'receiptAmount' | 'coverageAmount',
    value: number,
  ): void {
    throw new Error('Function not implemented.')
  },
  getMedicalExpenseTotal: function (): number {
    throw new Error('Function not implemented.')
  },
  initializeMedicalExpenses: function (apiData: any[], isNewPolicyType: boolean): void {
    throw new Error('Function not implemented.')
  },
  medicalExpenses: [],
  getMedicalExpenseItem: function (key: string): MedicalExpenseItem | undefined {
    throw new Error('Function not implemented.')
  },
  resetAllForms: () => undefined,
  resetOnPolicyChange: () => undefined,
  isNewPolicyType: null,
  isApprovedClaimAmountLocked: false,
  hasEditedOnce: false,
  markEditedOnce: () => undefined,
  selectedPolicy: undefined,
  selectedPolicyNumber: undefined,
  setSelectedPolicyOverride: () => undefined,
}

const HealthClaimFormContext = createContext(defaultValue)

export default HealthClaimFormContext
